define('OutSystems/ClientRuntime/Injector',["require", "exports", "./Logger"], function (require, exports, Logger) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.resolve = exports.removeRegistrationListener = exports.addRegistrationListener = exports.unregister = exports.register = void 0;
    var INJECTOR_MODULE_NAME = "Injector";
    var registered = {};
    var registrationHandlers = {};
    function register(service, implementation) {
        try {
            Logger.trace(INJECTOR_MODULE_NAME, "Registering ".concat(service, " service"));
            var serviceImplementation_1 = implementation();
            registered[service] = serviceImplementation_1;
            if (service in registrationHandlers) {
                registrationHandlers[service].forEach(function (handler) { return handler(service, serviceImplementation_1); });
            }
            return true;
        }
        catch (error) {
            Logger.trace(INJECTOR_MODULE_NAME, "Failed to initialize ".concat(service, " service: ").concat(error));
            return false;
        }
    }
    exports.register = register;
    function unregister(service) {
        delete registered[service];
    }
    exports.unregister = unregister;
    function addRegistrationListener(service, handler) {
        if (service in registrationHandlers) {
            registrationHandlers[service].push(handler);
        }
        else {
            registrationHandlers[service] = [handler];
        }
    }
    exports.addRegistrationListener = addRegistrationListener;
    function removeRegistrationListener(service, handler) {
        if (service in registrationHandlers) {
            registrationHandlers[service] = registrationHandlers[service].filter(function (h) { return h !== handler; });
        }
    }
    exports.removeRegistrationListener = removeRegistrationListener;
    function resolve(service) {
        return registered[service];
    }
    exports.resolve = resolve;
    var injectorImpl = {
        register: register,
        unregister: unregister,
        resolve: resolve,
        addRegistrationListener: addRegistrationListener,
        removeRegistrationListener: removeRegistrationListener,
    };
    exports.default = injectorImpl;
});
//# sourceMappingURL=Injector.js.map;
